// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"41e2bda3","338":"6e347eee"}[chunkId] + ".chunk.js";
};